import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, ElementRef, NgZone, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { PhoneNumber, PhoneNumberUtil } from "google-libphonenumber";
import { CookieService } from 'ngx-cookie-service';
import { CountryISO, SearchCountryField } from "ngx-intl-tel-input";
import { shareReplay } from 'rxjs/operators';
import { breadcrumbItem } from 'src/app/components/breadcrumbs/breadcrumbs.model';
import { TranslatePipe } from 'src/app/core/pipes/translate.pipe';
import { AlertService } from 'src/app/core/services/AlertService/alert.service';
import { IntegrationsService } from 'src/app/core/services/integrations.service';
import { ApiService } from 'src/app/services/api';
import { BreadcrumbService } from "src/app/services/breadcrumb";
import { TimezoneService } from 'src/app/services/timezone';
import { AppState } from 'src/app/store/app.state';
import { setLoadingSpinner } from 'src/app/store/sharedstate/shared.actions';
import { ChartType } from "../../../../app/pages/starter/net-sale/apex.model";
// import { TranslatePipe } from "src/app/core/pipes/translate.pipe";

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EmployeeListService } from 'src/app/core/services/employees/employee-list.service';
import { LocationsService } from 'src/app/core/services/locations/locations.service';
import { OnlineStoreServiceService } from 'src/app/core/services/online-store/online-store-service.service';
import { PermissionService } from 'src/app/core/services/permission.service';
import {
  lineColumAreaChart
} from "../../../../app/pages/starter/net-sale/data";
import { Country, States } from '../../integration/stripe-dashboard-page/stripe-details-page/country';
import { EditLicenseComponent } from '../../licenses/edit-license/edit-license.component';
import { NewLicenseComponent } from '../../licenses/new-license/new-license.component';

@Component({
  selector: 'app-merchants-details-component',
  templateUrl: './merchants-details.component.html',
  styleUrls: ['./merchants-details.component.scss'],
  providers: [TranslatePipe],
})

export class MerchantsDetailsComponent {
  token: string | string[];
  storeOptions: any;
  mailOptions:any;
  dropdownSettings1: { singleSelection: boolean; idField: string; textField: string; selectAllText: string; unSelectAllText: string; itemsShowLimit: number; allowSearchFilter: boolean; };
placeholder: any;
SearchCountryField = SearchCountryField;
f: any;
placeholderPhone: string = "415 234 5439";
preferredCountries: CountryISO[] ;
activationCode: any;
ViewPermission: boolean = false;

dropdownSettings: any;
revenueCenters: any;
roles: any;

  breadcrumbItems: breadcrumbItem[] = [
    {
        label: 'Home',
        active: false,
        url: "/home",
    },
    {
      label: 'Merchants',
      active: false,
      url: "/merchants",
      // url:"/merchants"
    },
    // {
    //   label: 'Customers',
    //   active: false,
    //   url:"/merchants/merchant-list",
    // },
    {
      label: 'Details',
      active: true,
      url:"",
    },
  ];
  @ViewChild('inviteEmployeeModal', { static: true }) private inviteEmployeeModal: ElementRef;

  IntegrationDetails = [
    {
      name: "Poynt",
      value: "POYNT",
      isIntegrated: false,
      img: "assets/images/integrations/poynt.png",
      p: "Equip Your Business with the Power of Poynt — Seamless, Secure Payment Simplified.",
      type: ["Payment"],
    },
    {
      name: "Totalpay",
      value: "TOTALPAY",
      isIntegrated: false,
      img: "assets/images/integrations/totalpay.png",
      p: "With eatOS and TotalPay, you can quickly and easily process credit card payments for online orders - it's never been easier!",
      type: ["Payment"],
    },
    {
      name: "Adyen",
      value: "ADYEN",
      isIntegrated: false,
      img: "assets/images/integrations/adyen.png",
      p: "With eatOS and Adyen, you can quickly and easily process credit card payments for online orders - it's never been easier!",
      type: ["Payment"],
    },
    // {
    //   name: "Quickbook",
    //   value: "QUICKBOOK",
    //   isIntegrated: false,
    //   img: "assets/images/integrations/quickbook.png",
    //   p: "QuickBooks is a leading accounting software platform that offers comprehensive solutions for small and medium-sized businesses to manage their financial operations. It simplifies and automates various accounting tasks, providing businesses with the tools they need to efficiently track income and expenses, manage invoices and payments, and generate accurate financial reports.",
    // },
    // {
    //   name: "MarketMan",
    //   value: "MARKETMAN",
    //   isIntegrated: false,
    //   img: "assets/images/integrations/marketman.jpg",
    //   p: "eatOS and MarketMan have collaborated to preserve food resources through meticulous cost monitoring and minimal wastage.",
    // },
    {
      name: "Doordash",
      value: "DOORDASH",
      isIntegrated: false,
      img: "assets/images/integrations/doordash.png",
      p: "Make takeout and delivery orders smoother than ever before! Streamline operations with eatOs & DoorDash integration.",
      type: ["Online Ordering"],
    },
    {
      name: "CardConnect",
      value: "CARDCONNECT",
      isIntegrated: false,
      img: "assets/images/integrations/CardConnect-logo.jpg",
      p: "With eatOS and CardConnect, you can quickly and easily process credit card payments for online orders - it's never been easier!",
      type: ["Payment"],
    },
    {
      name: "Stripe",
      value: "STRIPE",
      isIntegrated: false,
      img: "assets/images/integrations/stripe.png",
      p: "eatOS integrates with Stripe to offer a quick and simple solution for enabling ecommerce payments. Considering Stripe’s global reach, extensive toolkit, and user-friendliness, it makes it an easy choice to opt-in for and get going with orderOS online ordering.",
      type: ["Payment"],
    },
    {
      name: "eCard Systems",
      value: "ECARD",
      isIntegrated: false,
      img: "assets/images/integrations/eCard.png",
      p: "eatOS integrates with Ecard Systems to provide a giftcard solution. Ecards enables restaurants to adopt a simple and extremely customizable giftcard offering. Additional benefits include the ability to track analytics and manage giftcard programs. ",
      type: ["Loyalty", "Gift Cards"],
    },
    {
      name: "Yelp",
      value: "YELP",
      isIntegrated: false,
      img: "assets/images/integrations/yelp.png",
      p: "Make your business shine! Connect your Yelp page with eatOS and show customers why they should choose you. Tell them why your restaurant is the best!",
      type: ["Delivery"],
    },
    {
      name: "Gusto",
      value: "GUSTO",
      isIntegrated: false,
      img: "assets/images/integrations/gusto_logo.png",
      p: "Gusto payroll is the number one choice for specialty gift cards. They offer printing services and special packaging to make your gifts unique.",
      type: ["Payroll"],
    },
    {
      name: "Otter",
      value: "OTTER",
      isIntegrated: false,
      img: "assets/images/integrations/otter.png",
      p: "Otter makes managing your delivery data easy, so you can focus on boosting sales and eliminating delivery problems.",
      type: ["Online Ordering"],
    },
    {
      name: "Voucherify",
      value: "VOUCHERIFY",
      isIntegrated: false,
      img: "https://assets.website-files.com/60793752293570132aa47da2/60a7b732a601286d4033b33d_voucherify_logo_black.svg",
      p: "Voucherify is a program designed to help digital teams grow their businesses. It provides rewards and incentives so customers stay loyal, new ones join in, and you earn more money.",
      type: ["Loyalty"],
    },
    {
      name: "7Shifts",
      value: "7SHIFT",
      isIntegrated: false,
      // img: "https://eatos-beta.imgix.net/images/template/7shifts-2021.jpg",
      img: "https://d2w1ef2ao9g8r9.cloudfront.net/images/customer-logos/_indexThumbnailTransform/7shifts_logo.png",
      p: "Streamline payroll with 7shifts! Make it easier on yourself and enjoy simple tip management and payouts. Plus, use our engaging communication features to keep your staff in the loop. Get ready for a stress-free payroll experience!",
      type: ["Labor"],
    },
    {
      name: "Generative AI",
      value: "CHATGPT",
      isIntegrated: false,
      img: "https://d4.eatos.net/assets/images/companies/mayachatai.svg",
      p: "ChatGPT, developed by OpenAI, is an advanced language model capable of understanding and generating human-like text based on given prompts. It is widely used for tasks like content creation, customer support, and conversational agents.",
      //type: ["Loyalty", "Gift Cards"],
    },
    {
    name: "LoyaltyOS",
    value: "LoyaltyOS",
    isIntegrated: false,
    img: "assets/images/integrations/loyaltyOS.svg",
    p: "With loyaltyOS, you can quickly and easily process credit card payments for online orders - it's never been easier!",
    type: ["Payment"],
  },
  ];
  filteredIntegrationDetails = this.IntegrationDetails.filter(detail => detail.type?.includes('Payment'));

  public selectedCountryISO: any;
  @ViewChild("showInviteEmployeeModal") showInviteEmployeeModal;
  @ViewChild("showInviteEmployeeModal1") showInviteEmployeeModal1;
  @ViewChild("paymentIntegrationModal") paymentIntegrationModal;
  @ViewChild("loginOption") loginOption;


  @ViewChild("licencerenewpop") licencerenewpop;
  @ViewChild("logout") logout;


NewPIN: any;
  loginurl: any;
  loginmail: any;
  firststoreid: any;
  allIntegrationsWithAPIStatus: ({ isIntegrated: any; name: string; value: string; img: string; p: string; type: string[]; } | { isIntegrated: any; name: string; value: string; img: string; p: string; type?: undefined; })[];
  stores: any;
  storeintegration: any;
  appOptions = [
    { label: 'Point of Sale', value: 'POS' },
    { label: 'Point of Purchase', value: 'POP' },
    { label: 'KIOSK', value: 'KIOSK' },
    { label: 'Online Ordering', value: 'OnlineOrdering' }
  ];
  integrationdetails: any;
  cardconnectshow: boolean;
  loyaltyosshow: boolean;

  splitRules: any = [];
  showDateInput: boolean = false;
  pciExpireDateAvailable: boolean = false;
  isPciExpireDateFormatted: boolean;
  Storedata: any;

  constructor(private modalService: NgbModal, private translatePipe: TranslatePipe,
    private BreadcrumbService: BreadcrumbService, private store: Store<AppState>, private http: HttpClient,
    private renderer: Renderer2, private ApiService: ApiService, private cookieService: CookieService,
    private toastr: AlertService, public router: Router, private route: ActivatedRoute, private timezoneService: TimezoneService,
    private fb: FormBuilder,
    private locationService: LocationsService,
    private employeeListService: EmployeeListService,
    private ngZone: NgZone,
    private integrationService: IntegrationsService,
    private onlineStoreService: OnlineStoreServiceService,
    public permissionService: PermissionService,
  ) {
      this.GLOBALURL = this.ApiService.getBaseURL();
      this.token = this.cookieService.get('token');

    }

    loadData: boolean = false;
    merchantId = "";
    GLOBALURL: string;
    httpOptions2 = {};
    httpOptions = {};
    newPageForm: FormGroup;
    storeidform: FormGroup;
    ActiveCodeForm: FormGroup;
    paymentIntegrationForm: FormGroup;
    auditForm: FormGroup;

    headerToken = {
      "Content-Type": "application/json",
      Authorization: this.cookieService.get("token"),
    };
    storeId = this.cookieService.get("storeId");
    params = new HttpParams();
    merchantDetails: any;

    startDate: any = this.timezoneService.get()().subtract(29, "days").startOf('day');
    endDate: any = this.timezoneService.get()().endOf('day');
    // prevStartDate: any = this.timezoneService.get()().subtract(1, 'day').startOf('day');
    // prevEndDate: any = this.timezoneService.get()().subtract(1, 'day').endOf('day');
    prevStartDate: any = this.timezoneService.get()().subtract(60, "days").startOf('day');
    prevEndDate: any = this.timezoneService.get()().subtract(30, "days").endOf('day');

    startDateDisplay: any = this.startDate.unix();
    endDateDisplay: any = this.endDate.unix();
    prevStartDateDisplay: any = this.prevStartDate.unix();
    prevEndDateDisplay: any = this.prevEndDate.unix();
    currency: any = this.cookieService.get("currency");
    selectedStore: any = "";

    selectedTab: number = 1;
    // isContentLoading: boolean = false;
    hasAccess(module: string, requiredAccessLevel: number): boolean {
      return this.permissionService.canAccessSuper(module, requiredAccessLevel);
    }
    ngOnInit(): void {
      const userCountry = this.locationService.getUserCountry();
      this.preferredCountries = userCountry === CountryISO.UnitedKingdom
        ? [CountryISO.UnitedKingdom]
        : [userCountry, CountryISO.UnitedKingdom];
      // this.isContentLoading = true;
      this.BreadcrumbService.setValue(this.breadcrumbItems);
      this.dropdownSettings1 = {
        singleSelection: false,
        idField: 'revenueCenterId',
        textField: 'revenueCenterName',
        selectAllText: 'Select All',
        unSelectAllText: 'Unselect All',
        itemsShowLimit: 3,
        allowSearchFilter: true
      };
      // Checking Account is SuperAdmin
      if (this.cookieService.get("superAdminPage") !== "3") {
        this.toastr.error('Logged-in account should be a Super Admin.')
        this.router.navigate(['/home']);
        return;
      }
      // if (!this.permissionService.canAccessSuper('Merchants', 3)) {
      //   this.toastr.error("You are not authorized to perform this operation.");
      //   this.router.navigate(['/overview']);
      //   return;
      // }
      this.store.dispatch(setLoadingSpinner({ status: true }));

      // Retrieve the merchant ID from the route parameters
      this.merchantId = this.route.snapshot.paramMap.get('id');
      console.log("Merchant ID: & TypeOF", this.merchantId, typeof this.merchantId);
      // this.cookieService.set("merchantId", this.merchantId);
      this.params = this.params.set(
        "merchantId",
        this.merchantId
      );
      this.httpOptions2 = {
        headers: new HttpHeaders(this.headerToken),
        params: this.params,
      };
      // Set the merchant ID and Store ID in the cookie
      // this.cookieService.set("merchantId", this.merchantId);
      // this.cookieService.set("storeId", "*");

      this.getMerchantInformation();
      this.getNetSaleReport();
      this.isPastExpirationDate();
      // this.getRevenueCenter(this.storeId);
      // this.getRole(this.storeId, this.merchantId);
      this.ActiveCodeForm = this.fb.group({
        ActiveCode: ['', [Validators.required, Validators.maxLength(28)]],
      });
      this.auditForm = this.fb.group({
        pciAudit: [false],
        pciExpireDate: ['']
      });
      this.paymentIntegrationForm = this.fb.group({
        storeIdInt: ['', [Validators.required]],
        enableAppOptions: ['', [Validators.required]],
        defaultPayment: [false, [Validators.required]],
        splitConfigurationId: [''],
        username: [''],
        password: [''],
        merchantId: [''],
        Enablemultipleearnings: [false],
      });
      this.newPageForm = this.fb.group({
        employeeInfoData: this.fb.group({
          fname: ['', Validators.required],
          lname: ['', Validators.required],
          role: ['', Validators.required],
          dashboardAccess: [false],
          mail: [''],
          phoneNumber: [''],
          revenueCenters: [[],],
          pin:[
          "",
          [
            Validators.required,
            Validators.minLength(4),
            Validators.maxLength(4),
            Validators.pattern(/^\d{4}$/)
          ],
          ],
        }),
        storedata: this.fb.group({
          storeId: ['', Validators.required],
        }),
        logindata : this.fb.group({
          mailId: ['',Validators.required]
        })
      });
      this.newPageForm.get('employeeInfoData.dashboardAccess').valueChanges.subscribe((value) => {
        this.updateValidators(value);
        console.log("Dashboard Access: ", value);
      });
      // Initial validation management for paymentIntegrationForm
      this.managePaymentIntegrationValidators();
    }

    currentStore: string = "";
    getSplitConfigurations() {
      const httpOptions = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': this.token,
      });

      const params = new HttpParams().set('storeId', this.currentStore);


      this.http.get(this.GLOBALURL + '/adyen/splitConfig', { headers: httpOptions, params: params })
        .subscribe((response: any) => {
          if (response.success) {
            this.splitRules = response.data.map((rule) => {
              return {
                label: rule.description,
                value: rule.splitConfigurationId
              }
            });

            console.log("SPLIT RULES", this.splitRules);
          }
        },
        (error) => {

        });
    }

    splitConfigurationAssignedData: any;
    saveSplitConfigurations() {
      const httpOptions = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': this.token,
      });

      // const params = new HttpParams()
      // .set('storeId', this.currentStore)
      // .set('splitConfigurationId', this.paymentIntegrationForm.get('splitConfigurationId').value);

      let data = this.paymentIntegrationForm.value;

      let payload = {
        storeId: this.currentStore,
        splitConfigurationId: this.selectedSplitConfigurationId,
      }

      this.http.post(this.GLOBALURL + '/adyen/splitConfig', payload, { headers: httpOptions })
        .subscribe((response: any) => {
          if (response.success) {
            this.splitConfigurationAssignedData = response.data;
            console.log("success", response.message)  ;
          }
        },
        (error) => {
          console.log("ERROR", error);
        });
    }

    updateValidators(dashboardAccess: boolean): void {
      if (dashboardAccess) {
        console.log("Dashboard Access Enabled");
        this.newPageForm.get('employeeInfoData.mail').setValidators([Validators.required, Validators.email]);
        this.newPageForm.get('employeeInfoData.phoneNumber').setValidators([Validators.required]);
      } else {
        console.log("Dashboard Access Disabled");
        this.newPageForm.get('employeeInfoData.mail').clearValidators();
        this.newPageForm.get('employeeInfoData.phoneNumber').clearValidators();
      }
      this.newPageForm.get('employeeInfoData.mail').updateValueAndValidity();
      this.newPageForm.get('employeeInfoData.phoneNumber').updateValueAndValidity();
     console.log("Form: ", this.newPageForm, this.newPageForm.get('employeeInfoData').errors);
    }
  managePaymentIntegrationValidators() {
    if (this.cardconnectshow) {
      this.paymentIntegrationForm.get('username').setValidators([Validators.required]);
      this.paymentIntegrationForm.get('password').setValidators([Validators.required]);
      // this.paymentIntegrationForm.get('merchantId').setValidators([Validators.required]);
    } else {
      this.paymentIntegrationForm.get('username').clearValidators();
      this.paymentIntegrationForm.get('password').clearValidators();
      // this.paymentIntegrationForm.get('merchantId').clearValidators();
    }
    this.paymentIntegrationForm.get('username').updateValueAndValidity();
    this.paymentIntegrationForm.get('password').updateValueAndValidity();
    // this.paymentIntegrationForm.get('merchantId').updateValueAndValidity();
    }
    onSave() {
      const formData = this.newPageForm.value;
      console.log("Form Data: ", formData);
      const employeeInfo = formData.employeeInfoData;
      const employeeList = [
        {
          username: employeeInfo.mail ? employeeInfo.mail : "",
          mobile: employeeInfo.phoneNumber?.e164Number ? employeeInfo.phoneNumber.e164Number : "",
          firstName: employeeInfo.fname,
          lastName: employeeInfo.lname,
          roleId: employeeInfo.role,
          pincode: employeeInfo.pin,
          storeId: formData?.storedata.storeId,
          isUser: employeeInfo.dashboardAccess,
          revenueCenters: employeeInfo.revenueCenters.map((center: any) => center.revenueCenterId),          overrideJobType: false,
          payrollEnabled: false,
          employeeCustomId: ""
        }
      ];
      // this.store.dispatch(setLoadingSpinner({ status: true }));
      const params = {
        merchantId: this.merchantId,
        employeeList: employeeList
      };
      this.employeeListService.addEmployeeAdmin(params).subscribe(
        (response: any) => {
          this.store.dispatch(setLoadingSpinner({ status: false }));
          if (response.success) {
            const createdEmployee = response.response[0];

            if (!createdEmployee.invitationStatus) {
              const emailInvitatiionMsg = "This username has already been registered."

              if (createdEmployee.invitationMessage === emailInvitatiionMsg) {
                this.toastr.error("This email ID has already been registered.");
              } else {
                this.toastr.error(createdEmployee.invitationMessage);
              }
              return;
            }
            this.toastr.success(createdEmployee.invitationMessage);

          } else {
            this.toastr.error(response.message);
          this.store.dispatch(setLoadingSpinner({ status: false }));

          }
        },
        (error) => {
          this.store.dispatch(setLoadingSpinner({ status: false }));
          let message = error;
          this.toastr.error(message);
        }
      );

    }
    newRoleModel($event: any) {
    throw new Error('Method not implemented.');
    }

    clearForm(): void {
      this.newPageForm.reset({
        employeeInfoData: {
          fname: '',
          lname: '',
          role: '',
          dashboardAccess: false,
          mail: '',
          phoneNumber: '',
          revenueCenters: [],
          pin: '',
        },
        storedata: {
          storeId: '',
        }
      });
    }
    getRole(storeId: string, merchantId: string) {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: this.token,
      });

      const params = new HttpParams()
        .set('storeId', storeId)
        .set('merchantId', merchantId)
        .set('showLimitedData', 1);

      this.http
        .get<any>(this.GLOBALURL + '/role/super', { headers, params })
        .subscribe((response) => {
          this.roles = response.response;
          console.log("Roles: ", this.roles);
      });
          this.modalService.open(
            this.showInviteEmployeeModal,
            { centered: true, size: "lg" }
          );
    }
  login() {
    // let mail = "";
    console.log("this.loginmail",this.newPageForm.get('logindata.mailId').value, this.loginmail)
    // if (this.loginmail?.length) {
    //   mail = this.loginmail[0]?.employeeEmail;
    // }
    // else if (this.merchantDetails?.employee?.filter((item: any) => item.isOwner === true)) {
    //   const email = this.merchantDetails?.employee?.filter((item: any) => item.isOwner === true)
    //   mail = email[0]?.employeeEmail;
    // }
    // else if (this.merchantDetails?.employee[0]?.employeeEmail) {
    //   mail = this.merchantDetails?.employee[0]?.employeeEmail;
    // }
    // else {
    //   mail = this.merchantDetails?.employeeEmail;
    // }
    // let body = {
    //   "username": mail,
    // }
    let body = {
      "username": this.newPageForm.get('logindata.mailId').value,
    }

    return this.http.post(this.GLOBALURL + '/user/magiclink/super', body, this.httpOptions1).subscribe(
      (response: any) => {
        if (response.success == 0) {
          this.toastr.error(response.message)
          this.cancel();
          this.logindataClear()
        } else {
          // Save the login url in a cookie

          this.loginurl = response.response;
          console.log("Login URL: ", this.loginurl);
          this.cookieService.deleteAll();
          // Set the login URL in a cookie
          const loginUrlCookieName = 'loginUrl';
          this.cookieService.set(loginUrlCookieName, this.loginurl, undefined, '/');

          // Clear all cookies except the login url cookie
          this.clearAllCookiesExcept(loginUrlCookieName);

          // Clear localStorage and sessionStorage
          localStorage.clear();
          sessionStorage.clear();

          // Redirect to the login URL
          setTimeout(() => {
            window.location.href = this.loginurl;
          }, 2000);
          this.logindataClear()
          // window.top.close();
          // window.self.close();
          // Optionally, you can navigate to a route and then redirect
          // this.ngZone.run(() => {
          //   this.router.navigate(["account/login"]).then(() => {
          //     window.location.href = this.loginurl;
          //   });
          // });
        }
      },
      (error) => {
        this.cancel();
        let message = this.ApiService.errorMessage(error) || "An error occurred";
        if (message === "Username is empty" || message === "Username incorrect") {
          message = "Email address you used is not associated with eatOS."
        }
        this.toastr.error(message);
      }
    );
  }

clearAllCookiesExcept(exceptionName: string) {
  const allCookies = Object.keys(this.cookieService.getAll());
  for (const cookie of allCookies) {
    if (cookie !== exceptionName) {
      this.cookieService.delete(cookie, '/');
    }
  }
}
    cancel() {
      this.modalService.dismissAll();
    }
    getRevenueCenter(storeId: string) {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: this.token,
      });

    const params = new HttpParams()
      .set('storeId', storeId)
      .set('merchantId', this.merchantId);

      this.http
        .get<any>(this.GLOBALURL + '/revenueCenter/super', { headers, params })
        .subscribe((response: any) => {
          this.revenueCenters = response.response;
        });
    }
    merchantName: string = "";
    merchantAddress1: string = "";
    merchantAddress2: string = "";
    merchantCity: string = "";
    merchantState: string = "";
    merchantZipCode: string = "";
    merchantCountry: string = "";
    merchantEmailAccount: string = "";
    merchantType: string = "";
    merchantWebsite: string = "";
    merchantMobile: any;
    merchantPhoneCode: any;

    storeDetails: any = [];
    totalLocations: any = 0;
    subscriptionDetails: any;
    subscriptionDetails2: any;

    eatOSActiveStores: any;
    retailsOSActiveStores: any;
    breweryOSActiveStores: any;
    barOSActiveStores: any;

    totalEmployeesCount: any = 0;
    ownerEmployeeDetails: any;
    managerEmployeeDetails: any;

    allStoresintegrations: any = [];

    merchantSalesPerson: any = "";
    pciAudit: any = "";
    pciExpireDate: any = "";
    showInput: boolean = false;

    paginatedStoreDetails: any[] = [];
    currentPage: number = 1;
    itemsPerPage: number = 6;
    totalPages: number = 0;
    firstStore: any = {};
    // get Merchant information
    getMerchantInformation() {
      // this.detectChanges = true;
      // this.store.dispatch(setLoadingSpinner({ status: true }));
      return this.http
        .get(this.GLOBALURL + "/merchant/merchantById", this.httpOptions2)
        .subscribe(
          (response: any) => {
            if (response.success == 0 || response.error) {
              this.toastr.error(response.message);
              this.loadData = true;
              this.store.dispatch(setLoadingSpinner({ status: false }));
              // this.isContentLoading = false;
            } else {
              console.log("Merchant Information: ", response.response);
              this.currentStore = response.response.stores[0]._id;
              this.getSplitConfigurations();
              this.merchantDetails = response.response;
              this.storeOptions = this.merchantDetails.stores.map(store => ({
                label: store.storeName,
                value: store._id
              }));
              this.mailOptions = this.merchantDetails.employee
                .filter(employee => employee.employeeEmail) // Filters out undefined or empty email addresses
                .map(employee => ({
                  label: employee?.employeeFullName ? employee?.employeeFullName : employee?.employeeFirstName,
                  value: employee.employeeEmail
                }));
                console.log("mailOptions: ", this.mailOptions);
              this.Storedata = this.merchantDetails.stores
              console.log("Store Options: ", this.merchantDetails);
              this.stores = this.merchantDetails.stores;
              // this.firststoreid = this.merchantDetails.stores[0]._id;
              // this.getIntegrations(this.firststoreid);
              // this.loginmail = this.merchantDetails?.employee?.filter((item: any) => item.employeeEmail.includes('@eatos.co'));
              this.loginmail = this.merchantDetails?.employee?.filter((item: any) =>
                item.employeeEmail.includes('@eatos.co') && item?.isOwner === true
              );
              this.merchantSalesPerson = response.response?.merchantSalesPerson || "";
              this.pciAudit = response.response?.pciAudit || "";
              if (this.pciAudit) {
                this.auditForm.patchValue({
                  pciAudit: this.pciAudit
                });
              }
              this.pciExpireDate = response.response?.pciExpireDate || "";
              const value = this.formatDate(this.pciExpireDate)

              this.auditForm.patchValue({
                pciExpireDate: value
              });
              if(this.merchantSalesPerson == "") {
                this.showInput = false;
              } else {
                this.showInput = true;
              }
              if (this.storeDetails.length > 0) {
                this.storeintegration = this.storeDetails
                  .map(store => store.integrations || []) // Use default empty array if integrations is undefined
                  .flat(); // flat() method is used to flatten the array of arrays
                // this.getIntegrations(); // Add this call moved here if you need to call it again
              }
              if (response.response.stores.length > 0) {
                this.storeDetails = response.response.stores;
                this.totalPages = Math.ceil(this.storeDetails.length / this.itemsPerPage);
                this.updatePaginatedStoreDetails();
                this.totalLocations = response.response.stores.length;
                this.firstStore = response.response.stores[0];
                // get the total devices count for all stores
                this.storeDetails.forEach((store) => {
                  const summary = store.deviceDetails?.summary;
                  this.totalHardware += summary?.cfd + summary?.kiosk + summary?.pop + summary?.pos;
                });
              } else {
                this.storeDetails = [];
                this.totalLocations = 0;
                this.totalHardware = 0;
              }
              // Subscription Details
              this.subscriptionDetails = response.response?.subscriptionToken || {};
              this.subscriptionDetails2 = response.response?.subscription || {};

              // Employee Details
              this.ownerEmployeeDetails = response.response?.ownerEmployees || {};
              this.managerEmployeeDetails = response.response?.managerEmployees || {};
              this.totalEmployeesCount = response.response?.totalEmployeesCount || 0;

              // Active Stores Count based on appId
              if(this.storeDetails.length > 0) {
                this.eatOSActiveStores = this.storeDetails.filter(store => store.appId === "65c0d7c8339ad6658470cf34").length;
              this.retailsOSActiveStores = this.storeDetails.filter(store => store.appId === "65f01b0dacc70e483e82b55b").length;
              // This is for Demo purpose need to change the appId for Brewery and Bar
              this.breweryOSActiveStores = this.storeDetails.filter(store => store.appId === "65f01b0dacc70e483e82b55c").length;
              this.barOSActiveStores = this.storeDetails.filter(store => store.appId === "65f01b0dacc70e483e82b55d").length;
              } else {
                this.eatOSActiveStores = 0;
                this.retailsOSActiveStores = 0;
                this.breweryOSActiveStores = 0;
                this.barOSActiveStores = 0;
              }

              // Integrations
              // get All the Integrations from storeDetails Array property integrations, which is an array of objects
              if (this.storeDetails.length > 0) {
                this.allStoresintegrations = this.storeDetails
                  .map(store => store.integrations || []) // Use default empty array if integrations is undefined
                  .flat(); // flat() method is used to flatten the array of arrays
                console.log("All Stores Integrations: ", this.allStoresintegrations);
              }

          this.merchantName = response.response?.merchantName || "";
          this.merchantAddress1 = response?.response?.merchantAddress1 || "No Address available";
          this.merchantAddress2 = response?.response?.merchantAddress2 || "";
          this.merchantCity = response?.response?.merchantCity || "No City available";
          this.merchantState = response?.response?.merchantState || "No State available";
          this.merchantZipCode = response?.response?.merchantZipcode || "No Zipcode available";
          this.merchantCountry = response?.response?.merchantCountry || "";
          this.merchantEmailAccount = response?.response?.merchantEmail || "No Email available";
          this.merchantType = response?.response?.storeType
            ? response.response.storeType
            : "";
            const number = response.response?.merchantMobile
            ? this.getNationalNumber(response.response?.merchantMobile)
            : "";
            this.selectedCountryISO = this.getCountryCode(
                response.response?.merchantMobile
              );
              this.merchantMobile = number;
          this.merchantPhoneCode = response?.response?.merchantPhoneCode;
          this.merchantWebsite = response?.response?.merchantWebsite
            ? response.response?.merchantWebsite
            : "";
              this.loadData = true;
              this.store.dispatch(setLoadingSpinner({ status: false }));
              // this.isContentLoading = false;
              // this.toastr.success(response.message);
              // this.getDevices();
            }
          },
          (error) => {
            this.loadData = true;
            this.store.dispatch(setLoadingSpinner({ status: false }));
            const message = this.ApiService.errorMessage(error)
            this.toastr.error(message);
          }
        );
    }

    get displayedIntegrations() {
      return this.allStoresintegrations.slice(0, 3);
    }

    get remainingIntegrationsCount() {
      return this.allStoresintegrations.length - 3;
    }
    openInviteEmployeePopup() {
      console.log("Invite Employee Modal Opened",this.selectedStore);
      const selectedStores = this.newPageForm.get('storedata.storeId').value;
      console.log('Store IDs:', selectedStores);
      this.getRevenueCenter(selectedStores);
      this.getRole(selectedStores, this.merchantId);

        // this.modalService.open(
        //   this.showInviteEmployeeModal,
        //   { centered: true, size: "lg" }
        // );

    }
    preventSpace(event: KeyboardEvent) {
      if (event.key === ' ') {
        event.preventDefault();
      }
    }

    removeSpaces(event: Event) {
      const input = event.target as HTMLInputElement;
      input.value = input.value.replace(/\s+/g, '');
    }
    activate() {
      const otpValue = this.ActiveCodeForm.get('ActiveCode')?.value;
      const sanitizedOtpValue = otpValue.replace(/-/g, '');
        // console.log('OTP:', otpValue);
        const httpOptions2 = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': this.token
          })
        };
        let params = {
          "token": sanitizedOtpValue,
          "merchantId": this.merchantId,
        }
        return this.http.post(this.GLOBALURL + '/subscription/supervalidate', params, httpOptions2).subscribe(
          (response: any) => {
            if (response.success == 0) {
              this.toastr.error(response.message);
              this.cancel();
            } else {
              this.toastr.success("Account activated successfully");
              this.subscriptionDetails2.employeeLimit = this.newlyCreatedLicense?.employeeLimit
              this.subscriptionDetails2.accountLimit = this.newlyCreatedLicense?.accountLimit
              this.subscriptionDetails2.qsrLimit = this.newlyCreatedLicense?.qsrLimit
              this.subscriptionDetails2.kdsLimit = this.newlyCreatedLicense?.kdsLimit
              this.subscriptionDetails2.kioskLimit = this.newlyCreatedLicense?.kioskLimit
              this.subscriptionDetails2.fullLimit = this.newlyCreatedLicense?.fullLimit
              let newDateUnix = this.dateToUnix(this.newlyCreatedLicense?.expirationDate)
              this.subscriptionDetails2.expirationTime = newDateUnix;
              // This is the Update SUBSCRIPTIONTOKEN Model
              this.onSubmit();

              // const email = this.loginForm.value.email;
              // const password = this.loginForm.value.password;
              // this.store.dispatch(loginStart({ email, password }));
              // this.store.dispatch(setLoadingSpinner({ status: true }));
            }
          },
          error => {
            this.cancel();
            if (error.status === 500) {
              this.toastr.error("Error on subscription activation.");
            } else {
              this.toastr.error("An error occurred. Please try again.");
            }
            // this.alertService.error("Too many request, Please try after some time")
          }
        );
    }

    onSubmit(){
      // let info = this.f.value
      let expDate = this.dateToUnix(this.newlyCreatedLicense?.expirationDate)
      const subsriptionId = this.newlyCreatedLicense?._id || this.subscriptionDetails?._id;
      // if (this.licenseForm.valid) {
        let params ={
          expirationDate: expDate,
          employeeLimit: this.newlyCreatedLicense?.employeeLimit,
          accountLimit: this.newlyCreatedLicense?.accountLimit,
          qsrLimit: this.newlyCreatedLicense?.qsrLimit,
          kdsLimit: this.newlyCreatedLicense?.kdsLimit,
          kioskLimit:this.newlyCreatedLicense?.kioskLimit,
          fullLimit: this.newlyCreatedLicense?.fullLimit,
          subscriptionId: subsriptionId,
          status: 1,
        }

        //create
        // console.log(this.license[0])
        return this.http.put(this.GLOBALURL + '/subscription/update', params, this.httpOptions).subscribe((response: any) => {
          if (response.success == 0) {
              this.toastr.error(response.message);
          } else {

              this.toastr.success(response.message);
              if (this.merchantDetails?.status !== 1) {
                this.updateMerchantOnboard();
              } else {
                this.getMerchantInformation();
                this.cancel();
              }
          }
      }, (error) => {
          const message = this.ApiService.errorMessage(error)
          this.toastr.error(message);
      });

      // }
    }

    onSubmit2(){
      // let info = this.f.value
      // let expDate = this.dateToUnix(this.newlyCreatedLicense?.expirationDate)
      // const subsriptionId = this.newlyCreatedLicense?._id || this.subscriptionDetails?._id;
      // if (this.licenseForm.valid) {
        // let params ={
        //   expirationDate: expDate,
        //   employeeLimit: this.newlyCreatedLicense?.employeeLimit,
        //   accountLimit: this.newlyCreatedLicense?.accountLimit,
        //   qsrLimit: this.newlyCreatedLicense?.qsrLimit,
        //   kdsLimit: this.newlyCreatedLicense?.kdsLimit,
        //   kioskLimit:this.newlyCreatedLicense?.kioskLimit,
        //   fullLimit: this.newlyCreatedLicense?.fullLimit,
        //   subscriptionId: subsriptionId,
        //   status: 1,
        // }
        let params = this.subscriptionDetails2;

        //create
        // console.log(this.license[0])
        return this.http.post(this.GLOBALURL + '/subscription/update', params, this.httpOptions).subscribe((response: any) => {
          if (response.success == 0) {
              this.toastr.error(response.message);
          } else {

              this.toastr.success(response.message);
              // if (this.merchantDetails?.status !== 1) {
              //   this.updateMerchantOnboard();
              // } else {
              //   this.getMerchantInformation();
              //   this.cancel();
              // }
              this.getMerchantInformation();
          }
      }, (error) => {
          const message = this.ApiService.errorMessage(error)
          this.toastr.error(message);
      });

      // }
    }

    newlyCreatedLicense: any;
    Licencerenew(){
      // this.modalService.open(
      //   this.licencerenewpop,
      //   { centered: true, size: "md" }
      // )
      this.modalService.dismissAll();
    // const isParentCategory = true;
    const modal = this.modalService.open(NewLicenseComponent, {
      size: "lg newrole",
      centered: true
    })
    // modal.componentInstance.uniqueId = isParentCategory;
    modal.result.then((a) => {
      //close
    },
    (license) => {
      //dismiss
      // let employeePayloadData = this.f.value.employeeInfoData;
      // const revenueCenterIds = employeePayloadData.revenueCenters.length > 0 ? employeePayloadData.revenueCenters.map((c) => c.revenueCenterId) : [];
      if(license){
        console.log("IF_==license==", license);
        this.newlyCreatedLicense = license || {};
        // this.revenueCenters = [...this.revenueCenters, license];
        let activationCode = license?.key;
        // license?.newKey = this.chunk(response.response.key, 6).join('-');
        //     this.licensedKey = response.response.key;
        //     const chunks = this.licensedKey.match(/.{1,6}/g);
        //     this.licensedKey = chunks.join('-');

        // revenueCenterIds.push(license.revenueCenterId);
        // console.log("==revenueCenters==", this.revenueCenters);
        // take out the objects from this.parentCategoriesList whose ids are present in categoryIds
        // const newRevenueCenterList = this.revenueCenters.filter((cat) => {
        //   return revenueCenterIds.includes(cat.revenueCenterId);
        // });
        this.ActiveCodeForm.patchValue({
          ActiveCode: activationCode,
        });
        // This Updates the SUBSCRIPTION Model
        this.activate();
      }else{
        console.log("ELSE_==center==", license);
        // console.log("==revenueCenters==", this.revenueCenters);
        // console.log("==revenueCenterIds==", revenueCenterIds);
        // const newRevenueCenterList = this.revenueCenters.filter((cat) => {
        //   return revenueCenterIds.includes(cat.revenueCenterId);
        // });
        this.ActiveCodeForm.patchValue({
          ActiveCode: '',
        });
      }
    })
    }

    openEditLicenseModal() {
      this.modalService.dismissAll();
    const subsriptionId = this.subscriptionDetails?._id;
    const modal = this.modalService.open(EditLicenseComponent, {
      size: "lg newrole",
      centered: true
    })
    modal.componentInstance.subsriptionId = subsriptionId;
    modal.result.then((a) => {
      //close
    },
    (license) => {
      //dismiss
      // let employeePayloadData = this.f.value.employeeInfoData;
      // const revenueCenterIds = employeePayloadData.revenueCenters.length > 0 ? employeePayloadData.revenueCenters.map((c) => c.revenueCenterId) : [];
      if(license){
        console.log("UPDATE_==license==", license);
        // this.revenueCenters = [...this.revenueCenters, license];
        let activationCode = license?.key;
        // license?.newKey = this.chunk(response.response.key, 6).join('-');
        //     this.licensedKey = response.response.key;
        //     const chunks = this.licensedKey.match(/.{1,6}/g);
        //     this.licensedKey = chunks.join('-');

        // revenueCenterIds.push(license.revenueCenterId);
        // console.log("==revenueCenters==", this.revenueCenters);
        // take out the objects from this.parentCategoriesList whose ids are present in categoryIds
        // const newRevenueCenterList = this.revenueCenters.filter((cat) => {
        //   return revenueCenterIds.includes(cat.revenueCenterId);
        // });
        this.subscriptionDetails2.employeeLimit = license?.employeeLimit
              this.subscriptionDetails2.accountLimit = license?.accountLimit
              this.subscriptionDetails2.qsrLimit = license?.qsrLimit
              this.subscriptionDetails2.kdsLimit = license?.kdsLimit
              this.subscriptionDetails2.kioskLimit = license?.kioskLimit
              this.subscriptionDetails2.fullLimit = license?.fullLimit
              let newDateUnix = this.dateToUnix(license?.expirationDate)
              this.subscriptionDetails2.expirationTime = newDateUnix;
            console.log("subscriptionDetails2", this.subscriptionDetails2)
              this.onSubmit2();
        // this.getMerchantInformation();

      }else{
        console.log("ELSE_==center==", license);
        // console.log("==revenueCenters==", this.revenueCenters);
        // console.log("==revenueCenterIds==", revenueCenterIds);
        // const newRevenueCenterList = this.revenueCenters.filter((cat) => {
        //   return revenueCenterIds.includes(cat.revenueCenterId);
        // });
        // this.ActiveCodeForm.patchValue({
        //   ActiveCode: '',
        // });
      }
    })
    }
    LoginPopup() {
      this.modalService.open(
        this.loginOption,
        { centered: true, size: "lg" }
      )
    }
    Logout() {
      this.modalService.open(
        this.logout,
        { centered: true, size: "md" }
      )
    }
    openInviteEmployeePopup1() {
      this.modalService.open(
        this.showInviteEmployeeModal1,
        { centered: true, size: "lg" }
      )
    }
    openPaymentIntegrationPopup(name: string) {
      console.log("Payment Integration Modal Opened", name);
      this.integrationdetails = name;
      if (this.integrationdetails.value === "CARDCONNECT" || this.integrationdetails.value === "TOTALPAY") {
        this.cardconnectshow = true;
        this.loyaltyosshow = false;
      } else if (this.integrationdetails.value === "LoyaltyOS") {
        this.cardconnectshow = false;
        this.loyaltyosshow = true;
      } else {
        this.cardconnectshow = false;
        this.loyaltyosshow = false;
      }

      if (this.integrationdetails.value === "ADYEN") {
        //
        // if (this.splitRules.length === 0) {
        //   // this.toastr.error("No split configurations available for Adyen.");
        //   this.onboardAdyen();
        //   return;
        // }
        if (!this.adyenIntegration || this.adyenIntegration === undefined || this.adyenIntegration === null) {
          this.onboardAdyen();
          return;
        }
        console.log("AdyenIntegration",this.adyenIntegration)
        if (this.adyenIntegration?.storeId && this.adyenIntegration?.status === 'ACTIVE') {
          // this.toastr.error("Adyen is already integrated.");
          this.paymentIntegrationForm = this.fb.group({
            storeIdInt: [],
            enableAppOptions: [''],
            defaultPayment: [false],
            splitConfigurationId: [this.adyenIntegration?.splitConfigurationId || ''],
            username: [''],
            password: [''],
            merchantId: [''],
            Enablemultipleearnings: [false],
          });
          this.modalService.open(
            this.paymentIntegrationModal,
            { centered: true, size: "lg" }
          )
          return;
        }
        // else if (this.adyenIntegration?.storeId && this.adyenIntegration?.status === 'PENDING') {
        //   this.modalService.open(
        //     this.paymentIntegrationModal,
        //     { centered: true, size: "lg" }
        //   )
        //   return;
        // }
        else if (!this.adyenIntegration?.storeId && this.adyenIntegration?.status === 'PENDING') {
          this.onboardAdyen();
          return;
        }
      }

      this.managePaymentIntegrationValidators();
      this.modalService.open(
        this.paymentIntegrationModal,
        { centered: true, size: "lg" }
      )
    }
    logindataClear() {
      this.newPageForm.get('logindata.mailId').reset();
    }

    storeObj: any;
    adyenIntegration: any;
  getAdyenFromStore() {
    // this.store.dispatch(setLoadingSpinner({ status: true }));
    this.onlineStoreService.getCurrentStoreById(this.currentStore)
      .subscribe((res: any) => {
        if (res.success) {
          this.storeObj = res.response;
          this.adyenIntegration = res.response.integrations.find((integration) => integration.name === "ADYEN");
          console.log("ADYEN", this.adyenIntegration);
          // this.store.dispatch(setLoadingSpinner({ status: false }))
        }
      });
  }

    onboardAdyen() {
      console.log("CURRENT STORE", this.firstStore);
      const country = this.firstStore.storeCountry?.split(" ")?.join("");
      const countryValue = Country[country]?.toUpperCase() || "";
      const stateName = this.firstStore?.storeState;
      const states = States[countryValue]?.divisions;
      let stateValue = "";

      if (states) {
        for (const [code, name] of Object.entries(states)) {
          let tempName = String(name);
          if (tempName.toLowerCase() === stateName?.toLowerCase()) {
            stateValue = code.split("-")[1];
            break;
          }
        }
      }

      const now = new Date();
      const tenYearsAgo = new Date(now.getFullYear() - 10, now.getMonth(), now.getDate());
      const date = tenYearsAgo.toISOString().split('T')[0];
      const payload: any = {
        returnUrl: "https://d4.eatos.dev", // localhost:4200
        merchantId: this.merchantId,
        storeId: this.currentStore,
        businessData: {
          service: "paymentProcessing",
          industryCode: "446191",
          webData: [
              {
                  webAddress: "https://" + this.firstStore.storeWebpage,
              }
          ],
          salesChannels: ["eCommerce", 'pos', 'payByLink']
        },
        legalData: {
          type: "individual",
          individual: {
            residentialAddress: {
              city: this.firstStore.storeCity,
              country: countryValue,
              postalCode: this.firstStore.storeZipcode,
              stateOrProvince: stateValue,
              street: this.firstStore.storeAddress1,
              street2: this.firstStore.storeAddress2,
            },
            phone: {
              number: this.firstStore.storeMobile,
              type: "mobile"
            },
            name: {
              firstName: this.merchantDetails?.ownerEmployees?.employeeFirstName || "",
              lastName: this.merchantDetails?.ownerEmployees?.employeeLastName || "",
            },
            birthData: {
              dateOfBirth: date,
            },
            email: this.merchantDetails?.ownerEmployees?.employeeEmail || ""
          }
        }
      };

      this.store.dispatch(setLoadingSpinner({ status: true }))
      this.integrationService.installAdyen(payload)
        .subscribe((response: any) => {
          if (response.success) {
            this.toastr.clear();
            this.toastr.success(response.message);
            window.open(response.data.url, "_blank");
            this.store.dispatch(setLoadingSpinner({ status: false }))
          } else {
            this.toastr.clear();
            this.toastr.error(response.message);
            this.store.dispatch(setLoadingSpinner({ status: false }))
          }
        },
        (error) => {
          this.toastr.clear();
          if (error.includes("422")) {
            this.toastr.error("Please ensure the store postal code aligns with the store location.")
          }
          // this.toastr.error(error);
          this.store.dispatch(setLoadingSpinner({ status: false }))
        })
    }

    hasMoreIntegrations() {
      return this.remainingIntegrationsCount > 0;
    }

    getIntegrationImage(name) {
      return this.IntegrationDetails.find((i) => i.value === name)?.img || "";
    }

    getIntegrationName(name) {
      return this.IntegrationDetails.find((i) => i.value === name)?.name || "";
    }

    getIntegrationText(name) {
      return this.IntegrationDetails.find((i) => i.value === name)?.p || "";
    }

    updatePaginatedStoreDetails() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      this.paginatedStoreDetails = this.storeDetails.slice(startIndex, endIndex);
    }

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.updatePaginatedStoreDetails();
      }
    }

    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.updatePaginatedStoreDetails();
      }
    }

    // Method to get the initials from the merchant name
  getMerchantInitials(): string {
    const nameParts = this.merchantName.split(' ');
    if (nameParts.length === 1) {
      return nameParts[0].charAt(0).toUpperCase();
    }
    const firstInitial = nameParts[0].charAt(0).toUpperCase();
    const lastInitial = nameParts[nameParts.length - 1].charAt(0).toUpperCase();
    return `${firstInitial}${lastInitial}`;
  }

  getSalesPersonInitials(): string {
    const nameParts = this.merchantSalesPerson.split(' ');
    if (nameParts.length === 1) {
      return nameParts[0].charAt(0).toUpperCase();
    }
    const firstInitial = nameParts[0].charAt(0).toUpperCase();
    const lastInitial = nameParts[nameParts.length - 1].charAt(0).toUpperCase();
    return `${firstInitial}${lastInitial}`;
  }

     // Variable to track whether the license key is masked
  isLicenseKeyMasked: boolean = true;

  // Method to toggle the visibility of the license key
  toggleLicenseKeyVisibility() {
    this.isLicenseKeyMasked = !this.isLicenseKeyMasked;
  }

  // Method to get the masked license key
  getMaskedLicenseKey(): string {
    const key = this.subscriptionDetails?.key;
    if (!key) {
      return ''; // or return 'No license key available' if you want to show a message
    }
    return this.isLicenseKeyMasked ? `**** ${key.slice(-4)}` : key;
  }


  inviteEmployee() {
    // Logic to invite employee
    // This could be an API call or any other implementation
    this.showInviteEmployeeModal = false; // Example logic
  }
  // Method to get the formatted expiration date
  getFormattedExpirationDate(): string {
    // const expirationDate = this.subscriptionDetails?.expirationDate;
    const expirationDate = this.subscriptionDetails2?.expirationTime

    if (!expirationDate) {
      return '';
    }
    // return this.timezoneService.get()(expirationDate).format("DD MMM, YYYY");
    return this.timezoneService.get()(expirationDate, "X").format("DD MMM, YYYY");
  }
  isPastExpirationDate(): boolean {
    const expirationDateStr = this.getFormattedExpirationDate();
    if (!expirationDateStr) {
      return true; // Return true if expiration date is not available
    }

    const expirationDate = new Date(expirationDateStr);
    const today = new Date();
    return expirationDate < today;
  }

  _convertDate = (date: any) => {
      if (date) {
        return this.timezoneService
          .get()(date * 1000)
          .format("DD MMM, YYYY");
      } else {
        return "";
      }
  };

  // Method to calculate the total device count
  getDeviceCount(summary: any): number {
    return summary.cfd + summary.kiosk + summary.pop + summary.pos;
  }

  // Update Sales Person
  updateSalesPerson() {

    if (this.merchantSalesPerson == "") {
      this.showInput = true;
      return
    }

    var params = {
      merchantId: this.merchantId,
      merchantName: this.merchantName.trim(),
      merchantSalesPerson: this.merchantSalesPerson.trim(),
    };
    // console.log("Update entered")
    this.http
      .put(this.GLOBALURL + "/merchant", params, this.httpOptions2)
      .subscribe(
        (response: any) => {
          // console.log("done update", response);
          if (response.success == 0) {
            this.toastr.error(response.message);
          } else {
            this.toastr.success(response.message);
          }
        },
        (error) => {
          const message = this.ApiService.errorMessage(error)
          this.toastr.error(message);
        });
  }
  // formatDate(unixDate) {
  //   if (!unixDate) {
  //     return null;
  //   }
  //   return this.timezoneService.get().utc(unixDate).format("YYYY-MM-DD");
  // }
  formatDate(unixDate: number): string | null {
    if (!unixDate) {
      return null;
    }
    // Convert Unix timestamp to milliseconds and create a Date object
    const date = new Date(unixDate * 1000);
    // Format the date as "YYYY-MM-DD"
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  getFormattedpciExpireDate(): any {
    const pciExpireDate = this.pciExpireDate;
    if (!pciExpireDate) {
      this.pciExpireDateAvailable = true;
      this.isPciExpireDateFormatted = false;
      return '';
    }
    this.pciExpireDateAvailable = false;
    this.isPciExpireDateFormatted = true;

    const myDate = new Date(pciExpireDate * 1000);

    const day = ('0' + myDate.getDate()).slice(-2);
    const month = myDate.toLocaleString('default', { month: 'short' });
    const year = myDate.getFullYear();
    const formattedDate = `${day} ${month}, ${year}`;

    return formattedDate;
  }

  showDateInputUi(){
    this.showDateInput = true;
  }

   dateToUnix(date){
    let unix =this.timezoneService.get()(date).unix();
     return unix
   }

   updateMerchantOnboard() {
    var params = {
      merchantId: this.merchantId,
      // merchantName: this.merchantName.trim(),
      status: 1
    };

    this.http
      .put(this.GLOBALURL + "/merchant", params, this.httpOptions2)
      .subscribe(
        (response: any) => {
          // console.log("done update", response);
          if (response.success == 0) {
            this.toastr.error(response.message);
          } else {
            // this.toastr.success(response.message);
            this.getMerchantInformation();
            this.cancel();
          }
        },
        (error) => {
          const message = this.ApiService.errorMessage(error)
          this.toastr.error(message);
        });
  }

  updatePciaudit(data?: any) {
    console.log("data", this.pciExpireDate);
    // if(data == "date"){
    //   this.showDateInput = false;
    // }
    // if (this.pciExpireDate[0] == null) {
    //   console.log("this.pciExpireDate", this.pciExpireDate);
    //   return
    // }
    console.log('Updated form values:', this.auditForm.value);

    let expDate = this.dateToUnix(this.auditForm.value.pciExpireDate)

    var params = {
      merchantId: this.merchantId,
      merchantName: this.merchantName.trim(),
      pciAudit: this.auditForm.value.pciAudit,
      pciExpireDate: expDate,
      action: "superadmin"
    };
    // console.log("Update entered")
    this.http
      .put(this.GLOBALURL + "/merchant", params, this.httpOptions2)
      .subscribe(
        (response: any) => {
          // console.log("done update", response);
          if (response.success == 0) {
            this.toastr.error(response.message);
          } else {
            this.toastr.success(response.message);
          }
        },
        (error) => {
          const message = this.ApiService.errorMessage(error)
          this.toastr.error(message);
        });
  }
  textPrevious: string = "Previous";
  textCurrent: string = "Current";
  loader: Boolean = false;
  netSalesData: ChartType;
  httpOptions1 = { headers: new HttpHeaders(this.headerToken) };
  currentData: any = 0.0;
  prevData: any = 0.0;
  percentage: any = 0.0;
  async getNetSaleReport() {
    let params = {
      reportName: "home_report",
      query: {
        metric: "netSales",
        startDate: this.startDateDisplay,
        endDate: this.endDateDisplay,
        lastStartDate: this.prevStartDateDisplay,
        lastEndDate: this.prevEndDateDisplay,
        merchantId: this.merchantId,
        storeId: '*'
      },
    };
    this.loader = true;
    return this.http
      .post(this.GLOBALURL + "/reports/query", params, this.httpOptions1)
      .pipe(shareReplay(1))
      .subscribe(
        (response: any) => {
          if (response) {
            this.currentData = response.total;
            this.prevData = response.lastTotal;
            this.percentage = response.percentage;
            let dates = [];
            let currentDates = [];
            let lastDates = [];
            let currentData = [];
            let prevData = [];
            let cIntervalCounter = 1
            let pIntervalCounter = 1
            var push = false

            // console.log("netSales", response)
            if (response.lastIntervals) {
              response.lastIntervals.forEach((element) => {
                var date = element.key;
                if (this.startDate.diff(this.endDate, "days") === 0) {
                  push = true
                  // console.log("element.key", element.key)
                  date = this.timezoneService.get()(element.key).format("hh:mm A");
                } else {
                  // console.log("element.key_as_string", element.key_as_string);
                  // Parse the date string correctly
                  const parsedDate = this.timezoneService.get()(element.key_as_string, "MM-DD-YYYY");
                  date = parsedDate.format("MMM DD");
                }

                //if (push === true || pIntervalCounter < response.lastIntervals.length) {
                lastDates.push(date);
                prevData.push(element.netSales);
                //}
                pIntervalCounter++
              });
            }

            if (response.intervals) {
              response.intervals.forEach((element) => {
                var date = element.key;
                if (this.startDate.diff(this.endDate, "days") === 0) {
                  push = true
                  date = this.timezoneService.get()(element.key).format("hh:mm A");
                } else {
                  // Parse the date string correctly
                  const parsedDate = this.timezoneService.get()(element.key_as_string, "MM-DD-YYYY");
                  date = parsedDate.format("MMM DD");
                }

                //if (push === true || cIntervalCounter < response.intervals.length) {
                currentDates.push(date);
                currentData.push(element.netSales);
                //}

                cIntervalCounter++
              });
            }

            for (let i = 0; i < currentDates.length; i++) {
              let stringDate = ''
              if (push)
                stringDate = currentDates[i]
              else
                stringDate = currentDates[i] + " - " + lastDates[i]
              dates.push(stringDate);
            }

            // response.lastIntervals.forEach(element => {
            //   prevData.push(element.netSales)
            // });
            // console.log("THIS>CURRENCY_TY", typeof this.currency, this.currency)
            // if this.currency is undefined or null, set it to $ by default else use the value to this.currency
            let graphCurrency: string;
            if (this.currency == undefined || this.currency == null) {
              graphCurrency = "$";
            } else {
              graphCurrency = this.currency;
            }

            const lineColumAreaChart: ChartType = {
              chart: {
                height: 350,
                type: "line",
                // dropShadow: {
                //   enabled: true,
                //   color: '#000000',
                //   top: 15,
                //   left: 7,
                //   blur: 10,
                //   opacity: 0.4,
                // },
                stacked: false,
                toolbar: {
                  show: false,
                },
              },
              stroke: {
                width: 3,
                curve: "smooth",
              },
              // plotOptions: {
              //   bar: {
              //     columnWidth: '100%'
              //   }
              // },
              colors: ["#000000", "#cccccc"],
              series: [
                {
                  name: this.textCurrent,
                  type: "line",
                  data: currentData,
                },
                {
                  name: this.textPrevious,
                  type: "line",
                  data: prevData,
                },
              ],
              fill: {
                opacity: [1, 1],
                gradient: {
                  inverseColors: true,
                  shade: "light",
                  type: "vertical",
                  opacityFrom: 1,
                  opacityTo: 1,
                  stops: [0, 100, 100, 100],
                },
              },
              // tslint:disable-next-line: max-line-length
              labels: dates,
              markers: {
                size: 0,
              },
              // legend: {
              //   offsetY: 10,
              //   markers: {
              //     width: 7,
              //     height: 7
              //   },
              // },
              xaxis: {
                type: "dateTime",
                axisBorder: {
                  show: true,
                  color: "#d2d2d2",
                  height: 1,
                  width: "100%",
                  offsetX: 0,
                  offsetY: 0,
                },
                axisTicks: {
                  show: true,
                  borderType: "solid",
                  color: "#d2d2d2",
                  height: 6,
                  offsetX: 0,
                  offsetY: 0,
                },
              },
              yaxis: {
                // title: {
                //     text: 'Points',
                // },
                labels: {
                  formatter: function (value) {
                    // return "$ " + parseInt(value);
                    return graphCurrency + ' ' + parseInt(value);
                  },
                },
              },
              tooltip: {
                shared: true,
                intersect: false,
                y: {
                  formatter(y) {
                    if (typeof y !== "undefined") {
                      // return "$ " + y.toLocaleString("en-US");
                      return graphCurrency + ' ' + y.toLocaleString("en-US");
                    }
                    return y;
                  },
                },
              },
              grid: {
                borderColor: "#000000",
              },
              responsive: [
                {
                  breakpoint: 480,
                  options: {
                    chart: {
                      height: "auto",
                      type: "line",
                    },
                  },
                },
              ],
            };
            window.dispatchEvent(new Event('resize'));
            this.netSalesData = lineColumAreaChart;
            this.loader = false;
          } else {
            //this.toastr.error(response.message);
            this.loader = false;
          }
        },
        (error) => {
          this.netSalesData = lineColumAreaChart;
          this.loader = false;
          //this.toastr.success(error.message, { autoClose: false });
          //jQuery(".allpageLoader").css("display","none");
        }
      );
  }

  // offset: any = 0;
  limit: any = 0;
  totalHardware: any = 0;
  hardwares: any = [];
  hardwareCopy: any = [];
    // Get HArdware Devices
    getDevices() {
      this.hardwares = [];
      this.hardwareCopy = [];
      // this.store.dispatch(setLoadingSpinner({ status: true }));
      this.params = this.params.set("limit", this.limit);
      this.params = this.params.set("showLimitedData", 1);
      // merchantId
      this.params = this.params.set("merchantId", this.merchantId);
        this.httpOptions = {
          headers: new HttpHeaders(this.headerToken),
          params: this.params,
        };

      return this.http
        .get(this.GLOBALURL + "/device", this.httpOptions)
        .subscribe(
          (response: any) => {
            if (response.success == 0) {
              this.toastr.error(response.message);
              this.store.dispatch(setLoadingSpinner({ status: false }));
            } else {
              response.response.forEach((element) => {
                this.hardwares.push(element);
                this.hardwareCopy.push(Object.assign({}, element));
              });
              // this.sortByName(this.hardwares, "deviceName", false);
              // this.sortByName(this.hardwareCopy, "deviceName", false);
              this.hardwares.forEach((element2, index) => {
                element2.index = index;
              });
              this.hardwareCopy.forEach((element3, index) => {
                element3.index = index;
              });
              this.totalHardware = response.total;
              this.store.dispatch(setLoadingSpinner({ status: false }));
            }
          },
          (error) => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            const message = this.ApiService.errorMessage(error)
            this.toastr.error(message);
          }
        );
    }

    getNationalNumber(phoneNumber: string): string {
      // console.log("phoneNumber", typeof (phoneNumber), phoneNumber)
      const phoneUtil = PhoneNumberUtil.getInstance();
      let parsedNumber: PhoneNumber;

      try {
        parsedNumber = phoneUtil.parse(phoneNumber);
      } catch (error) {
        console.error('Invalid country code or number:', error);
        return null; // or return a default value or an error message
      }

      return phoneUtil.getNationalSignificantNumber(parsedNumber);
    }

    getCountryCode(phoneNumber: string): string {
      // console.log("phoneNumber_Country_Code", phoneNumber)
      try {
        const phoneUtil = PhoneNumberUtil?.getInstance();
        // console.log("phoneUtil_FROM_TRY_BLOCK", phoneUtil)
        const parsedNumber: PhoneNumber = phoneUtil.parse(phoneNumber);
        // console.log("parsedNumber_FROM_TRY_BLOCK", parsedNumber)
        // console.log("phoneUtil.getRegionCodeForNumber(parsedNumber)", phoneUtil.getRegionCodeForNumber(parsedNumber))
        return phoneUtil?.getRegionCodeForNumber(parsedNumber);
      } catch (error) {
        // console.error("Error parsing phone number:", error);
        return "US";
      }
    }

    selectTab(tabIndex: number) {
      this.selectedTab = tabIndex;
      this.getAdyenFromStore();
    }

  isDivVisible: boolean = false;

  showUrbanCalifornia() {
    this.isDivVisible = !this.isDivVisible;
  }
  // getIntegrations(storeid?: string) {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     Authorization: this.cookieService.get('token'),
  //   });

  //   this.http.get<any>(`${this.GLOBALURL}/store?storeId=${storeid}&integration=1`, { headers })
  //     .subscribe((response: any) => {
  //       console.log('Integrations:', response.response.integrations);
  //       this.storeintegration = response.response.integrations;
  //       this.filterIntegrationStatus(this.storeintegration);
  //     });
  // }

  // filterIntegrationStatus(apiIntegrations: any[]) {
  //   if (!Array.isArray(apiIntegrations)) {
  //     console.error('Invalid apiIntegrations received, expected an array but got: ', apiIntegrations);
  //     this.allIntegrationsWithAPIStatus = this.filteredIntegrationDetails.map((integration) => ({
  //       ...integration,
  //       isIntegrated: false,
  //     }));
  //     return;
  //   }

  //   // Create a Set from the names in apiIntegrations array for quick lookup
  //   const integratedNames = new Set(apiIntegrations.map(integration => integration.name));

  //   this.allIntegrationsWithAPIStatus = this.filteredIntegrationDetails.map((integration) => {
  //     return {
  //       ...integration,
  //       isIntegrated: integratedNames.has(integration.value),
  //     };
  //   });
  // }
  selectAll() {
    const allStoreIds = this.storeOptions.map(option => option.value);
    this.paymentIntegrationForm.get('storeIdInt').setValue(allStoreIds);
  }

  deselectAll() {
    this.paymentIntegrationForm.get('storeIdInt').setValue([]);
  }
  // onStoreChange(event: any) {
  //   this.getIntegrations(event.target.value);
  //   // this.firststoreid = event.target.value;
  // }
  onPaymentIntegrationSubmit() {
    console.log('Form Value:', this.paymentIntegrationForm.value);
    console.log('Integrate Payment', this.integrationdetails);
    // Inject currentStore for Adyen only
    if (this.integrationdetails && this.integrationdetails.value === 'ADYEN') {
      console.log('currentStore', this.currentStore);
      this.paymentIntegrationForm.get('storeIdInt').setValue([this.currentStore]);
    }
    this.integratepayment(this.paymentIntegrationForm.value, this.integrationdetails);
  }

  selectedSplitConfigurationId: any;
  integratepayment(data: any, Name: any) {
    const token = this.cookieService.get('token');

    // Common query string parameters
    const queryParams = new HttpParams()
      // .set('storeId', data.storeIdInt.join(','))
      // .set('integration', '1');

    const commonPayload = {
      storeId: data.storeIdInt?.join(','),
      merchantId: this.merchantId,
      enableAppOptions: data.enableAppOptions,
      defaultPayment: data.defaultPayment,
    };

    // Integration-specific payloads
    const LoyaltyPayload = {
      ...commonPayload,
      integrations: [
        {
          allowMultipleEarnings: data.Enablemultipleearnings,
          enabled: true,
          name: "LoyaltyOS"
        }
      ]
    };

    const TotalPayPayload = {
      ...commonPayload,
      integrations: [
        {
          name: 'TOTALPAY',
          merchantKey: data.username,
          password: data.password,
          enabled: true,
          type: 'PAYMENT',
          sync: {
            time: '',
            syncNow: false
          }
        }
      ]
    };

    const CardConnectPayload = {
      ...commonPayload,
      integrations: [
        {
          enabled: true,
          name: "CARDCONNECT",
          username: data.username,
          password: data.password,
          merchantId: data.merchantId
        }
      ]
    };

    const AdyenPayload = {
      ...commonPayload,
      integrations: this.firstStore.integrations
        .filter(integration => integration.name === 'ADYEN')
        .map((integration, index) => {
          if (index === 0) {
            return { ...integration, splitConfigurationId: data?.splitConfigurationId };
          }
          return integration;
        })
    }

    let payload = {};

    if (Name.value === "CARDCONNECT") {
      payload = CardConnectPayload;
    } else if (Name.value === "LoyaltyOS") {
      payload = LoyaltyPayload;
    } else if (Name.value === "TOTALPAY") {
      payload = TotalPayPayload;
    } else if (Name.value === "ADYEN") {
      payload = AdyenPayload;
      this.selectedSplitConfigurationId = data?.splitConfigurationId;
      console.log('splitConfigurationId:', this.selectedSplitConfigurationId);
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: token
    });

  return this.http.post<any>(`${this.GLOBALURL}/store/integrations/super`, payload, { headers, params: queryParams })
      .subscribe(
        (response: any) => {
          console.log('Integration Response:', response);
          this.toastr.success(response.message);
          this.clearIntegrationForm();
          console.log('splitConfigurationId:', this.selectedSplitConfigurationId);
          this.modalService.dismissAll();
          if (Name.value === "ADYEN") {
            this.saveSplitConfigurations();
          }
        },
        (error: any) => {
          console.error('Error integrating payment:', error);
          this.modalService.dismissAll();
          this.toastr.error('Error integrating payment. Please try again.');
        }
      );
  }

  clearIntegrationForm(): void {
    this.paymentIntegrationForm.reset({
      storeIdInt: '',
      enableAppOptions: '',
      defaultPayment: false,
      username: '',
      password: '',
      merchantId: '',
      Enablemultipleearnings: false
    });

    // If you use any flags to show or hide inputs based on conditions, reset them here
    this.cardconnectshow = false;
    this.loyaltyosshow = false;

    // Optionally, re-run validator management if necessary
    this.managePaymentIntegrationValidators();
  }

  isEditing = false;
  toggleEdit() {
    this.isEditing = !this.isEditing;
  }

  onStoreChange(event: any) {
    this.currentStore = event.target.value;
    // You can add additional logic here to handle store change
    // For example, refresh integrations for the selected store
  }

}
